import {
  styled,
  rem
} from 'config/stitches.config'

import Button from '@/UI/Button'

export const StyledIndex = styled('aside', {
  position: 'fixed',
  left: 0,
  top: '50%',
  marginLeft: rem(72),
  zIndex: 3,
  width: 170,
  opacity: 0,
  transform: 'translateY(-50%) translateX(-100%)',
  display: 'none',
  transition: 'opacity ease-in-out .4s, transform ease-in-out .4s',
  variants: {
    isVisible: {
      true: {
        opacity: 1,
        transform: 'translateY(-50%) translateX(0%)',
      }
    }
  },
  '@md': { display: 'block', }
})

export const StyledIndexList = styled('ul', {
  padding: rem(2),
  margin: 0,
  listStyle: 'none',
  display: 'flex',
  flexDirection: 'column',
  rowGap: rem(11),
  position: 'relative',
  '&::before': {
    left: 0,
    content: '',
    position: 'absolute',
    top: '50%',
    lef: 0,
    width: 8,
    height: 'calc(100% - 7px)',
    backgroundColor: '#E8E8E8',
    br: 30,
    transform: 'translateY(-50%)',
  }
})

export const StyledIndexButton = styled(Button, {
  // paddingY: `${rem(11)} !important`,
  height: 14,
  width: '100%',
  position: 'relative',

  'span': {
    textAlign: 'left',
    fontSize: rem(12),
    lineHeight: rem(14),
    whiteSpace: 'nowrap',
    position: 'absolute',
    transform: 'translateY(-50%)',
    top: '50%',
    left: '$2',
    transition: 'opacity ease-in-out .4s',
    // opacity: 0, De-comment to show only the current index
  },

  '&::before': {
    transition: 'transform ease-in-out .4s',
    content: '',
    flexShrink: 0,
    transformOrigin: 'center center',
    transform: 'scale(1,1)',
    width: 4,
    height: 4,
    br: '50%',
    backgroundColor: '#9E9E9E',
  },

  '&:hover': {
    '&::before': {
      backgroundColor: '$primary',
      transform: 'scale(1.5,1.5)',
    }
  },

  variants: {
    middle: {
      true: {
        'span': {
          opacity: 1,
          color: '$gray1'
        },
        // '&::before': {
        //   transitionDelay: '.3s', transform: 'scale(1.5, 1.5)',
        // },
      },
    },
    current: {
      true: {
        'span': {
          fontSize: rem(14),
          opacity: 1,
          color: '$black',
          fontWeight: '$3'
        },
        '&::before': {
          backgroundColor: '$primary',
          transform: 'scale(1.5,1.5)',
        },
      }
    },
    variant: {
      default: { color: '$primary' },
      inverted: { color: '$white' }
    }
  }
})

export const StyledIndexListItem = styled('li', {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  position: 'relative',
  columnGap: rem(12),
  maxWidth: '100%',
})

export const StyledHistoryIndex = styled('div', {
  display: 'grid',
  gap: rem(46)
})
export const StyledHistoryIndexList = styled(StyledIndexList, { rowGap: rem(24), })

export const StyledHistoryIndexListItem = styled(StyledIndexListItem, { [StyledIndexButton]: { span: { fontSize: rem(16) } } })

export const StyledHistoryIndexLabel = styled('span', {
  fontSize: rem(18),
  fontWeight: 'bold'
})
